import React from 'react';
import PropTypes from 'prop-types';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import ReviewSkeleton from '@hydra/common/components/ReviewSkeleton';
import CriteriumChart from '@hydra/common/criterium/CriteriumChart';
import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumText from '@hydra/common/criterium/CriteriumText';

export const PjFbInsightDemographics = ({ criterium }) => {
  const { translate } = useI18n();
  if (!criterium) {
    return (
      <Criterium criterium={{ type: 'pj_fb_insight_demographics', score: null, importance: 0, solvability: 0 }} clickable={false}>
        <ReviewSkeleton height={366} />
      </Criterium>
    );
  }

  const { data } = criterium;

  const toArray = object => Object.keys(object).map(key => [key, object[key]]);

  const impressionsM = toArray(data.impressions_by_age_gender_unique.m);
  const impressionsF = toArray(data.impressions_by_age_gender_unique.f);
  const engagementM = toArray(data.content_activity_by_age_gender_unique.m);
  const engagementF = toArray(data.content_activity_by_age_gender_unique.f);

  const impressionsChartData = [
    {
      name: translate('pj_so_impressions_by_age_gender_unique_M'),
      data: impressionsM.map(([ageRange, value]) => {
        return ({ x: ageRange, y: value });
      })
    },
    {
      name: translate('pj_so_impressions_by_age_gender_unique_F'),
      data: impressionsF.map(([ageRange, value]) => {
        return ({ x: ageRange, y: (value * -1) });
      })
    }
  ];

  const engagementChartData = [
    {
      name: translate('pj_so_storytellers_by_age_gender_M'),
      data: engagementM.map(([ageRange, value]) => {
        return ({ x: ageRange, y: value });
      })
    },
    {
      name: translate('pj_so_storytellers_by_age_gender_F'),
      data: engagementF.map(([ageRange, value]) => {
        return ({ x: ageRange, y: (value * -1) });
      })
    }
  ];

  const impressionsData = [
    Object.values(data.impressions_by_age_gender_unique.m),
    Object.values(data.impressions_by_age_gender_unique.f)
  ];

  const activityData = [
    Object.values(data.content_activity_by_age_gender_unique.m),
    Object.values(data.content_activity_by_age_gender_unique.f)
  ];

  const isSeriesEmpty = data => data.every(series => series.every(dataPoint => dataPoint === 0));

  return (
    <Criterium criterium={criterium}>
      {(isSeriesEmpty(impressionsData) || isSeriesEmpty(activityData)) && <CriteriumText firstLine={<Translate content='pj_facebook_missing_metrics_data' />} />}
      <CriteriumChart type='bar' data={[...impressionsChartData, ...engagementChartData]} hasLegend hasTooltip />
    </Criterium>
  );
};

PjFbInsightDemographics.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      impressions_by_age_gender_unique: PropTypes.object,
      storytellers_by_age_gender: PropTypes.object
    })
  })
};

export default React.memo(PjFbInsightDemographics);
